import {
  NetworkError,
  PermissionDeniedError,
  ResourceNotFoundError,
  UnknownApplicationError,
  ValidationError
} from '@/lib/errors';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Button, XStack, YStack } from 'tamagui';
import { BodyText, SectionTitle } from '@/components/ui/Typography';
import Container from './Container';

interface ErrorDisplayProps {
  error?: Error | null;
  onRetry?: () => void;
  onDismiss?: () => void;
  retryText?: string;
  backText?: string;
  title?: string;
  message?: string;
}

function getErrorTitle(error: Error): string {
  if (error instanceof ResourceNotFoundError) {
    return 'Not found';
  }
  if (error instanceof PermissionDeniedError) {
    return 'Permission Denied';
  }
  if (error instanceof ValidationError) {
    return 'Invalid data';
  }
  if (error instanceof NetworkError) {
    return 'Network error';
  }
  if (error instanceof UnknownApplicationError) {
    return 'Unexpected error';
  }
  return 'Unexpected error';
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onRetry,
  onDismiss,
  title,
  message,
}) => {
  if (!error) return null;
  return (
    <Container>
      <YStack f={1} ai="center" jc="center" p="$5">
        <YStack
          backgroundColor="white"
          borderRadius="$6"
          p="$6"
          w="100%"
          ai="center"
          gap="$4"
          // maxWidth={420}
          shadowColor="#000"
          shadowOpacity={0.08}
          shadowRadius={14}
          elevation={4}
        >
          <Ionicons name="alert-circle-outline" size={48} color="#DC2626" />

          <SectionTitle
            color="#111"
            textAlign="center"
          >
            {title || getErrorTitle(error)}
          </SectionTitle>

          <BodyText
            color="#555"
            textAlign="center"
          >
            {message || error.message || 'An unexpected error occurred'}
          </BodyText>

          <XStack w="100%" jc={'center'} gap="$3" mt="$3">
            {onRetry && (
              <Button
                f={1}
                bg="#374151"
                color="white"
                br="$6"
                onPress={onRetry}
                pressStyle={{ opacity: 0.8 }}
                maxWidth={200}
              >
                Try again
              </Button>
            )}
            {onDismiss && (
              <Button
                f={1}
                bw={1}
                borderColor={'#374151'}
                bg="white"
                br="$6"
                onPress={onDismiss}
                pressStyle={{ bg: "#F8FAFC" }}
                maxWidth={200}
              >
                Back
              </Button>
            )}
          </XStack>
        </YStack>
      </YStack>
    </Container>
  );
};
